import { apiSlice } from 'app/api/apiSlice'

export const RoleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: () => ({
        url: '/role/',
      }),
      keepUnusedDataFor: 60 * 60 * 24,
      providesTags: ['Role'],
    }),
  }),
  overrideExisting: true,
})

export const { useGetRolesQuery } = RoleApiSlice
